import Annotation from "./annotation";

class FourSquareGrid extends Annotation {
  constructor() {
    super();

    this.color = "#00b0f0";
    this.lineWidth = 1;
    this.space = 0.25;
    this.canvasSize = null;
  }

  draw(ctx) {
    if (!this.canvasSize) 
      return;
    
      ctx.lineWidth = this.lineWidth;
      ctx.strokeStyle = this.color;
      ctx.fillStyle = this.color;
      
      let margin = Math.min(this.canvasSize.w, this.canvasSize.h) * this.space;
      let length = Math.min(this.canvasSize.w, this.canvasSize.h) - margin;
      
      let maxX = length;
      let minX = (this.canvasSize.w - length) /2;

      let maxY = length;
      let minY = (this.canvasSize.h - length) /2;;

      ctx.strokeRect(minX, minY, maxX, maxY);

      ctx.beginPath();
      ctx.moveTo(maxX / 2 + minX, minY);
      ctx.lineTo(maxX / 2 + minX, minY + maxY);
      ctx.stroke();
      ctx.closePath();
  
      ctx.beginPath();
      ctx.moveTo(minX, maxY / 2 + minY);
      ctx.lineTo(minX + maxY, maxY / 2 + minY);
      ctx.stroke();
      ctx.closePath();
  }
}

export default FourSquareGrid;